




























































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import { findAreas } from "@/components/picker/area-data-for-vant";
import _ from "lodash";
const { mapGetters } = createNamespacedHelpers("login");

export default Vue.extend({
    name: "IdentityInfoCell",
    props: {
        info: {
            type: Object,
            default: function() {
                return {};
            }
        },
        isForeign: {
            type: Boolean,
            default: false
        },
        idCardImage: {
            type: String
        },
        idCardBackImage: {
            type: String
        },
        idPhotoImage: {
            type: String
        },
        orgConfig: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(["loggedIn"]),
        areaNames(): string {
            if (!this.info.provincial) {
                return "";
            }
            const areas = findAreas(this.info.provincial, this.info.city, this.info.district);
            return _.map(areas, "text").join("");
        },
        detailedHouseholdLocation() {
            return _.replace(this.info.householdLocation as string, this.areaNames as string, "");
        },
        isNewUser() {
            return !this.info.identityNo;
        },
        showNationalityType(): boolean {
            if (Object.keys(this.orgConfig).length == 0) {
                return false;
            }
            return !!this.orgConfig["showNationalityType"];
        }
    },
    methods: {
        safeGo(path: string): string {
            return this.loggedIn ? path : "/login";
        }
    }
});
